var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 0C15.2694 0.000438905 15.2058 0.0100864 15.1445 0.0286458C15.1265 0.0335379 15.1087 0.0391853 15.0911 0.0455729L0.433594 4.70703V4.70964C0.30642 4.75709 0.196762 4.84224 0.119279 4.95369C0.0417972 5.06514 0.000183098 5.19759 0 5.33333C0.000242845 5.44781 0.0299603 5.5603 0.0862899 5.65996C0.142619 5.75962 0.223663 5.84309 0.321615 5.90234L4.77604 9.4362L13.582 2.41797L6.5638 11.224L10.0951 15.6758C10.1542 15.7746 10.238 15.8564 10.3381 15.9132C10.4383 15.97 10.5515 15.9999 10.6667 16C10.8024 15.9998 10.9349 15.9582 11.0463 15.8807C11.1578 15.8032 11.2429 15.6936 11.2904 15.5664H11.293L15.9583 0.895833C15.9631 0.88252 15.9674 0.869058 15.9714 0.855469C15.9899 0.794236 15.9996 0.730649 16 0.666667C16 0.489856 15.9298 0.320286 15.8047 0.195262C15.6797 0.0702379 15.5101 0 15.3333 0Z",
    fill: "#3367CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.06ad40ca.svg";
export { ForwardRef as ReactComponent };